export default __webpack_public_path__ + "static/active-student-participation-435648822cd46a60f59c547759833cd2.png";